import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../../services/apiService";
import { downEnrollment } from "../../../services/terminal/enrollmentTerminalService";
import { post, put } from "../../../services/apiService";
import { SetEnrollmentSelected } from "./LoadEnrollment.slice";

const LOAD_ENROLLMENT = "loadEnrollment/getList";
const LOAD_ENROLLMENT_RETRIEVE = "loadEnrollment/retrieve";
const LOAD_ENROLLMENT_DELETE = "loadEnrollment/delete";
const LOAD_ENROLLMENT_CREATE = "loadEnrollment/create";
const LOAD_ENROLLMENT_UPDATE = "loadEnrollment/update";

export const getEnrollmentLoadList = createAsyncThunk(
  LOAD_ENROLLMENT,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, enrollment_type = "MERCHANT_ISO", ...rest } = payload;
    const url = "/dashboard/enrollment-data-temp";
    try {
      const params = {
        enrollment_type,
        ...rest,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const { data, page, page_size, total_pages, total_records } = await get(
        url,
        config
      );

      const enrollmentData = data.map((item) => {
        const { data: itemData } = item;
        if (["MERCHANT_ISO", "MERCHANT_ACQUIRER"].includes(enrollment_type)) {
          const {
            acquirer: {
              name: acquirerName,
              email: acquirerEmail,
              merchantID: acquirerId,
            },
          } = itemData;
          return {
            ...item,
            acquirerName,
            acquirerEmail,
            acquirerId,
          };
        } else if (enrollment_type === "ISO") {
          const {
            iso: { address: isoAddress, email: isoEmail, isoName },
          } = itemData;
          return {
            ...item,
            isoAddress,
            isoEmail,
            isoName,
          };
        } else if (enrollment_type === "ACQUIRER") {
          const {
            acquirer: { countryCode },
            acquirerName,
          } = itemData;
          return {
            ...item,
            acquirerName,
            countryCode,
          };
        } else {
          return item;
        }
      });

      return {
        enrollmentData,
        page,
        page_size,
        total_pages,
        total_records,
      };
    } catch (error) {
      console.error("Error fetching enrollment data thunk:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getEnrollmentByIdLoad = createAsyncThunk(
  LOAD_ENROLLMENT_RETRIEVE,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, id } = payload;
    const url = `/dashboard/enrollment-data-temp/${id}`;
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const enrollmentFilterdById = await get(url, config);
      return { enrollmentFilterdById };
    } catch (error) {
      console.error("Error fetching enrollment data by id thunk:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEnrollmentLoad = createAsyncThunk(
  LOAD_ENROLLMENT_DELETE,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, id } = payload;
    try {
      const enrollmentDeleted = await downEnrollment({ token, id });
      return { enrollmentDeleted };
    } catch (error) {
      console.error("Error fetching enrollment data by id thunk:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const createEnrollmentLoad = createAsyncThunk(
  LOAD_ENROLLMENT_CREATE,
  async (payload, { rejectWithValue, dispatch }) => {
    const {
      token,
      formData,
      enrollment_type = "MERCHANT_ISO",
      userMail,
      currentStep,
      enrollment_completed = false,
    } = payload;
    const url = "/dashboard/enrollment-data-temp";
    try {
      const enrollmentData = {
        email: userMail,
        enrollment_type,
        data: formData,
        enrollment_completed,
        current_step: currentStep,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await post(url, enrollmentData, config);
      // const { id } = response;
      // dispatch(SetEnrollmentSelected({ enrollmentSelected: id }));
      return { enrollmentCreated: response };
    } catch (error) {
      console.error("Error creating enrollment thunk:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateEnrollmentLoad = createAsyncThunk(
  LOAD_ENROLLMENT_UPDATE,
  async (payload, { rejectWithValue }) => {
    const {
      token,
      formData,
      enrollment_type = "MERCHANT_ISO",
      userMail,
      enrollmentId,
      currentStep,
      enrollment_completed = false,
    } = payload;
    const url = `/dashboard/enrollment-data-temp/${enrollmentId.id}`;
    try {
      const enrollmentData = {
        email: userMail,
        enrollment_type,
        data: formData,
        enrollment_completed,
        current_step: currentStep,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await put(url, enrollmentData, config);
      return { enrollmentUpdated: response };
    } catch (error) {
      console.error("Error updating enrollment thunk:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
